module.exports = __webpack_public_path__ + "static/media/next.484e14c4.svg";